<template>
  <div class="step-shell">
    <header
      v-if="title || intro"
      class="step-shell__header"
    >
      <h2
        v-if="title"
        class="step-shell__title"
      >
        {{ title }}
      </h2>
      <p
        v-if="intro"
        class="step-shell__intro"
      >
        {{ intro }}
      </p>
    </header>

    <div class="step-shell__body">
      <slot />
    </div>

    <Teleport
      v-if="mounted && !hideFooter"
      to="#onboarding-footer"
    >
      <div class="step-shell__footer">
        <SpmButton
          v-if="canGoBack"
          :label="t('completeV2.backCta')"
          icon="far fa-arrow-left"
          class-style="p-button p-button-text p-button-secondary"
          @click="$emit('back')"
        />
        <div class="step-shell__footer-spacer" />
        <slot name="footer-extra" />
        <SpmButton
          :label="continueLabel || t('completeV2.continueCta')"
          class-style="p-button p-button-success"
          :disabled="continueDisabled"
          :loading="continueLoading"
          @click="$emit('next')"
        />
      </div>
    </Teleport>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

export default defineComponent({
  name: 'StepShell',

  components: {
    SpmButton,
  },

  props: {
    title: { type: String, default: '' },
    intro: { type: String, default: '' },
    canGoBack: { type: Boolean, default: false },
    continueLabel: { type: String, default: '' },
    continueDisabled: { type: Boolean, default: false },
    continueLoading: { type: Boolean, default: false },
    hideFooter: { type: Boolean, default: false },
  },

  emits: ['next', 'back'],

  setup() {
    const { t } = useI18n();
    const mounted = ref(false);
    onMounted(() => { mounted.value = true; });
    return { t, mounted };
  },
});
</script>

<style lang="scss" scoped>
.step-shell {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 36rem;
  margin: 0 auto;
  padding: 0.5rem 0;

  &__header {
    margin-bottom: 1.75rem;
  }

  &__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 0.6rem;
    line-height: 1.25;
    letter-spacing: -0.01em;
  }

  &__intro {
    font-size: 0.92rem;
    color: #475569;
    margin: 0;
    line-height: 1.55;
  }

  &__body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.step-shell__footer {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  max-width: 36rem;
  margin: 0 auto;
}

.step-shell__footer-spacer {
  flex: 1;
}
</style>
